/**
 * 描述：自定义ng-if 无scope阻隔
 * 日期：2017-7-6
 * 作者：bai.zhiming
 */
"use strict";
angular.module("trsNgIfModule",[]).directive("trsNgIf",[function(){
	return {
		restrict:"A",
		replace:true,
		transclude: false,
		link:function(scope, elemt, attrs){
			if(attrs.trsNgIf==="false"){
				elemt.remove();
			}
		}
	};
}]);